/**
 * This util gets the target for urls
 * It returns `_blank` for external urls ( non miro.com ) and `_self` for internal ( miro.com and relative )
 */ function getLinkTarget(url) {
    if (url?.startsWith('http') && !url?.startsWith('https://miro.com')) {
        return '_blank';
    }
    return '_self';
}

export { getLinkTarget as default };
